export default {"src":"/_next/static/media/carOutlinePatch_24.8b5d31db.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};